import {
  IntegrationSettingsAccountLevelForm,
  IntegrationSettingsForm,
  IntegrationSettingsLevel,
  IntegrationSettingsLocationLevelForm,
  IntegrationSettingsUserLevelForm,
} from '../types';
import { InsertIntegrationSettingsValues } from '../api/types';

type SyndicatedRow = Record<string, unknown>;

// Syndicated ISVs store an array under the primary field; convert to each integration's saved shape.
const shapeSyndicatedValues = (
  integrationSettingsValues: Record<string, unknown> | null
): Record<string, unknown> | null => {
  if (!integrationSettingsValues) return integrationSettingsValues;

  if (Array.isArray(integrationSettingsValues.dealerId)) {
    return {
      dealerId: (integrationSettingsValues.dealerId as SyndicatedRow[]).map(row => ({
        value: (row.dealerId as string) || (row.value as string) || '',
        dealerId: (row.dealerId as string) || (row.value as string) || '',
        displayName: row.displayName || '',
        accountId: row.accountId || '',
        vendorProfileId: row.vendorProfileId || '',
        externalVendorId: row.externalVendorId || '',
        ...(row.locationId ? { locationId: row.locationId } : {}),
      })),
      externalVendorId: [],
    };
  }

  if (Array.isArray(integrationSettingsValues.partnerDealerId)) {
    return {
      partnerDealerId: (integrationSettingsValues.partnerDealerId as SyndicatedRow[]).map(row => ({
        value: row.value || '',
        accountId: row.accountId || '',
        displayName: row.displayName || '',
        vendorProfileId: row.vendorProfileId || '',
        ...(row.locationId ? { locationId: row.locationId } : {}),
      })),
    };
  }

  return integrationSettingsValues;
};

export const formatIntegrationSettingsFormDataToPayload = (
  integrationName: string,
  formData: IntegrationSettingsForm
) => {
  return Object.keys(formData).reduce<InsertIntegrationSettingsValues>((acc, key) => {
    const integrationLevelSettings = Object.values(formData[key as IntegrationSettingsLevel] || {}) as
      | IntegrationSettingsUserLevelForm[]
      | IntegrationSettingsLocationLevelForm[]
      | IntegrationSettingsAccountLevelForm[];

    if (!integrationLevelSettings?.length) return acc;

    const levelSettings = integrationLevelSettings
      .filter(
        item =>
          item.integrationSettingsValuesId ||
          Object.values(item.integrationSettingsValues || {}).some(item =>
            Array.isArray(item) ? item.length > 0 : !!item
          )
      ) // to exclude non touched rows
      .map(item => ({
        integrationName,
        integrationSettingsValuesId: item.integrationSettingsValuesId,
        integrationSettingsValues: shapeSyndicatedValues(
          item.integrationSettingsValues as Record<string, unknown> | null
        ),
        userProfileId: 'userProfileId' in item ? item.userProfileId : undefined,
        locationId: 'locationId' in item ? item.locationId : undefined,
        accountId: 'accountId' in item ? item.accountId : undefined,
      }));

    return [...acc, ...levelSettings];
  }, []);
};
